import { render, staticRenderFns } from "./ads-item.vue?vue&type=template&id=5fbf5c78&scoped=true&"
import script from "./ads-item.vue?vue&type=script&lang=js&"
export * from "./ads-item.vue?vue&type=script&lang=js&"
import style0 from "./ads-item.vue?vue&type=style&index=0&id=5fbf5c78&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbf5c78",
  null
  
)

export default component.exports